import { createContext, useContext, useEffect } from "react"

type WorkspaceShellTitleContextValue = {
  setShellTitle: (title: string | null) => void
}

export const WorkspaceShellTitleContext = createContext<WorkspaceShellTitleContextValue | null>(null)

export function useWorkspaceShellTitle(title: string | null) {
  const ctx = useContext(WorkspaceShellTitleContext)

  useEffect(() => {
    if (!ctx) return
    ctx.setShellTitle(title)
    return () => ctx.setShellTitle(null)
  }, [ctx, title])
}
